/**
 * 7-2 サインアップ
 */
import routes from "routes"
import HTMLHead from "src/components/utils/HTMLHead"
import React, { useContext, useMemo } from "react"
import SocialLoginButton from "src/components/common/auth/SocialLoginButton"
import { DefaultLayoutForReader } from "src/components/common/layouts/DefaultLayoutForReader"
import { usePermission } from "src/components/hooks/usePermission"
import { globalStoreContext } from "src/store/GlobalStore"
import Link from "next/link"

export const SignUp: React.FC = () => {
  const {
    globalStore: {
      user: { clientState },
    },
  } = useContext(globalStoreContext)

  const redirectUrl = useMemo(() => {
    if (clientState === 1) {
      return routes.authCreatorProfile()
    } else {
      return routes.mypage()
    }
  }, [clientState])
  usePermission([0], redirectUrl)

  return (
    <DefaultLayoutForReader>
      <HTMLHead path="auth/sing-up" />
      <main>
        <header className="p-signIn-header">
          <h1 className="p-signIn-header-title">新規会員登録</h1>
        </header>

        <section className="p-signIn-section">
          <div className="p-signIn-section-inner">
            <div className="p-signIn-sns-col -signup">
              <Link href={routes.authCreatorProfile()}>
                <a className="c-button-secondary" style={{ width: "100%" }}>
                  メールアドレスで登録
                </a>
              </Link>
            </div>
            <div className="p-signIn-sns-col -signup">
              <SocialLoginButton providerName="twitter-signup" />
            </div>
            <div className="p-signIn-sns-col -signup">
              <SocialLoginButton providerName="google-signup" />
            </div>
          </div>
        </section>
      </main>
    </DefaultLayoutForReader>
  )
}

export default SignUp
